module.exports = __webpack_public_path__ + "static/media/dysway-logo-colori.ea586932.png";